import styled from "styled-components/macro";
import { Text } from "@gcs/design-system/react";

export const CorporativeCultureContainer = styled.section(({ theme }) => ({
  padding: "0 16px 40px",

  [theme.breakpoint.lg()]: {
    padding: "50px 112px 60px",
  },
}));

export const CorporativeCultureTitle = styled(Text)(({ theme }) => ({
  color: theme.color.brandPrimary.light,
  padding: "16px 0 8px 0",
  width: "fit-content",
  fontSize: "20px",
  lineHeight: "150%",


  [theme.breakpoint.lg()]: {
    fontSize: "24px",
  },
}));

export const CorporativeCultureParagraph = styled(Text)(({ theme }) => ({
  color: theme.color.neutral["02"],
  fontWeight: 500,
  lineHeight: "160%",
  maxWidth: "calc(100% - 40px)",
  fontSize: "18px",

  [theme.breakpoint.lg()]: {
    fontSize: "20px",
  },
}));

export const CorporativeCultureHeadType = styled.div(({ theme }) => ({
  fontSize: "32px",
  fontWeight: 700,
  lineHeight: "150%",
  color: theme.color.neutral["02"]
}));

export const CorporativeCultureContent = styled.div(({ theme }) => ({
  paddingTop: "32px",
  gap: "32px",
  maxWidth: "1200px",
  display: "flex",
  flexDirection: "column",
  
  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    flexDirection: "row",
    rowGap: "28px",
    columnGap: "0",
    flexWrap: "wrap",
  },
}));

export const CorporativeCultureTopic = styled.div(({ theme }) => ({
  padding: "0 0 32px 0",
  borderBottom: `1px solid ${theme.color.line.medium}`,
  [theme.breakpoint.lg()]: {
    padding: "0 0 60px 0",
  },

  ":last-child": {
    borderBottom: "none",
    padding: "32px 0 0 0",
    [theme.breakpoint.lg()]: {
      padding: "60px 0 0 0",
    },
  }
}))

export const CorporativeCultureItem = styled.div(() => ({
  maxWidth: "598px",

  ":last-child": {
      "@media(min-width: 1440px)": {
        maxWidth: "100%"
      },
    }
}))
